import React, { ReactNode, VFC } from 'react';
import RenderLazyLoad from './RenderLazyLoad';

interface Props {
  invisibleComponent?: ReactNode;
  observerOptions?: IntersectionObserverInit;
  children: ReactNode;
}
const LazyLoadComponent: VFC<Props> = ({
  invisibleComponent = null,
  observerOptions,
  children,
}: Props) => (
  <RenderLazyLoad
    observerOptions={observerOptions}
    render={({ isVisible }) => (isVisible ? children : null)}
  />
);

export default LazyLoadComponent;
